import { lazy } from "react";

const RELOAD_FLAG = "iims-reloaded-for-new-version";

// React.lazy for a page, so each module's code is only downloaded when the
// page is first opened instead of on every visit to the app.
//
// After a deploy, someone who still has the old version open may ask for a
// code file that no longer exists. Reload once to pick up the new version,
// rather than leaving a broken page; a second failure is shown as an error.
export const lazyPage = (importPage) =>
  lazy(() =>
    importPage()
      .then((module) => {
        safeSession(() => window.sessionStorage.removeItem(RELOAD_FLAG));
        return module;
      })
      .catch((error) => {
        const alreadyReloaded = safeSession(() =>
          window.sessionStorage.getItem(RELOAD_FLAG)
        );
        if (!alreadyReloaded) {
          safeSession(() => window.sessionStorage.setItem(RELOAD_FLAG, "1"));
          window.location.reload();
          return new Promise(() => {});
        }
        throw error;
      })
  );

const safeSession = (fn) => {
  try {
    return fn();
  } catch {
    return null;
  }
};
